<template>
  <v-container>
    <div class="mt-0 mb-2" style="display:flex;flex-direction:row;align-items:center;">
      <div class="mr-5">
        <v-btn @click="volver()" icon color="white">
          <v-icon large>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
      <div>
        <h2 class="grey--text text--lighten-3" style="font-size: 25pt;">Registrarme como Productor</h2>
        <p class="grey--text text--lighten-2 mb-0" style="font-size: 15pt;">
          Construyamos juntos el calendario de suministro mas grande de Colombia. Al registrarte ayudaremos a promover tu cultivo, encontrar apoyo para los principales problemas de tu finca y te conectaremos con las mejores oportunidades.
        </p>
      </div>
    </div>
    <div>
      <v-stepper
        v-model="stepperRegistro"
        vertical
        :style="{background: $vuetify.theme.themes.dark.secondary}"
      >
        <v-stepper-step step="1" :complete="stepperRegistro > 1">
          <span style="line-height: 30px;">¿Que producto tienes?</span>
          <small>A registrar tu producto este sera visible en el calendario y un comprador podra contactarte</small>
        </v-stepper-step>

        <v-stepper-content step="1">
          <div class="mb-3">
            <div>
              <v-form ref="formProducto">
                <!-- Seleccion Producto -->
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="produccion.producto"
                      :items="productos"
                      chips
                      clearable
                      hide-details="auto"
                      hide-selected
                      item-text="nombre"
                      item-value="idProducto"
                      label="¿Que producto produces?"
                      outlined
                      return-object
                      :rules="[rules.required]"
                    >
                      <template v-slot:selection="{ attr, on, item, selected }">
                        <v-chip
                          pill
                          v-bind="attr"
                          :input-value="selected"
                          :color="item.imagen.colors[2][0]"
                          class="white--text"
                          v-on="on"
                        >
                          <v-avatar left>
                            <v-img :src="item.imagen.url"></v-img>
                          </v-avatar>
                          <span v-text="item.nombre"></span>
                        </v-chip>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.nombre"></v-list-item-title>
                          <v-list-item-subtitle
                            v-if="item.tipoProducto=='agricola'&&item.categoria"
                            v-text="item.categoria.categoriaGeneral.nombre"
                          ></v-list-item-subtitle>
                          <v-list-item-subtitle v-else>Producto Pecuario</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-select
                      v-model="produccion.extension.extensionObj.unidad"
                      item-text="nombre.plu"
                      :items="variablesForm.unidadesExtension"
                      return-object
                      label="Unidad Extensión Producción"
                      name="unidadExtension"
                      :rules="[rules.required]"
                      outlined
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                      v-if="produccion.extension.extensionObj.unidad"
                      v-model="produccion.extension.extensionObj.valor"
                      label="Extensión Cultivo"
                      outlined
                      :suffix="produccion.extension.extensionObj.unidad.nombre.plu"
                      name="extension"
                      type="number"
                      :rules="[rules.required]"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <p
                  class="mb-0 mt-2"
                  style="padding:0;font-size:14pt;height: 40px;color: hsla(0,0%,100%,.7);"
                >
                  Próximo Rango de Producción
                  <span
                    v-if="produccion.producto"
                  >{{produccion.producto.nombre}}</span>
                </p>

                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-dialog
                      ref="dialogRangoStart"
                      v-model="modelRangoProduccionStart"
                      :return-value.sync="rangoProduccionStart"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="rangoProduccionStart"
                          label="Fecha Inicio Cosecha"
                          readonly
                          outlined
                          hide-details="auto"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="pickerStart"
                        v-model="rangoProduccionStart"
                        scrollable
                        locale="es-mx"
                        :min="new Date().toISOString()"
                        :max="rangoProduccionEnd"
                        color="accent"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="modelRangoProduccionStart = false"
                        >Cancelar</v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialogRangoStart.save(rangoProduccionStart)"
                        >Aceptar</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-dialog
                      ref="dialogRangoEnd"
                      v-model="modelRangoProduccionEnd"
                      :return-value.sync="rangoProduccionEnd"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="rangoProduccionEnd"
                          label="Fecha Fin Cosecha"
                          readonly
                          outlined
                          v-on="on"
                          hide-details="auto"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="pickerEnd"
                        v-model="rangoProduccionEnd"
                        scrollable
                        locale="es-mx"
                        :min="rangoProduccionStart"
                        color="accent"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="modelRangoProduccionEnd = false"
                        >Cancelar</v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialogRangoEnd.save(rangoProduccionEnd)"
                        >Aceptar</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>

                <p
                  class="mb-0 mt-2"
                  style="padding:0;font-size:14pt;height: 40px;color: hsla(0,0%,100%,.7);"
                >
                  Volumen Aproximado de la Producción
                  <span
                    v-if="produccion.producto"
                  >{{produccion.producto.nombre}}</span>
                </p>

                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="produccion.rangoProduccion.volumen.frecuencia"
                      item-text="nombrePeriodicidad"
                      :items="variablesForm.unidadesFrecuencia"
                      return-object
                      label="Frecuencia"
                      name="frecuencia"
                      :rules="[rules.required]"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="produccion.rangoProduccion.volumen.unidad"
                      item-text="Name.Plu.es"
                      :items="variablesForm.unidadesPeso"
                      return-object
                      label="Unidad Volumen"
                      name="unidadExtension"
                      :rules="[rules.required]"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                      v-if="produccion.rangoProduccion.volumen.unidad"
                      v-model="produccion.rangoProduccion.volumen.valor"
                      label="Cantidad"
                      outlined
                      :suffix="produccion.rangoProduccion.volumen.unidad.Name.Plu.es"
                      name="extension"
                      type="number"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-btn color="primary" @click="continuarFincaStepper">Continuar</v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-step step="2" :complete="stepperRegistro > 2">
          <span style="line-height: 30px;">Cuéntanos sobre tu finca</span>
          <small>Como se llama?, que terreno tienes?, donde esta ubicada?</small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <div>
            <div>
              <v-form ref="formFinca">
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                      v-model="nuevaFinca.nombre"
                      label="Nombre Finca"
                      type="text"
                      name="nombreFinca"
                      :rules="[rules.required]"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="nuevaFinca.extension.extensionObj.unidad"
                      item-text="nombre.plu"
                      :items="variablesForm.unidadesExtension"
                      return-object
                      label="Unidad Extensión Finca"
                      name="unidadExtension"
                      :rules="[rules.required]"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                      v-if="nuevaFinca.extension.extensionObj.unidad"
                      v-model="nuevaFinca.extension.extensionObj.valor"
                      label="Extensión Productiva Finca"
                      outlined
                      :suffix="nuevaFinca.extension.extensionObj.unidad.nombre.plu"
                      name="extension"
                      type="number"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-subheader style="padding:0;">Ubicación</v-subheader>

                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="idPais"
                      item-text="nombre_pais"
                      item-value="id_pais"
                      :items="variablesForm.paises"
                      label="Pais"
                      hide-details="auto"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="departamento"
                      item-value="id_departamento"
                      item-text="nombre"
                      :items="variablesForm.departamentos"
                      label="Departamento"
                      @change="getCiudades(departamento)"
                      name="departamento"
                      outlined
                      return-object
                      :rules="[rules.required]"
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="municipio"
                      :items="variablesForm.municipios"
                      :rules="[rules.required]"
                      item-value="id_ciudad"
                      item-text="nombre_ciudad"
                      label="Municipio"
                      name="municipio"
                      @change="setMunicipio(municipio)"
                      outlined
                      return-object
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-text-field
                      v-model="nuevaFinca.data.puntoReferencia"
                      label="¿En que vereda esta ubicada la finca?"
                      hint="Ej: Vereda Chince, a 2 km de la estacion de gasolina"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-subheader
                  style="padding:0;font-size:14pt;height: 40px;"
                >Via de Acceso y Fuente de Agua</v-subheader>

                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="nuevaFinca.viaAcceso.tipo"
                      item-text="nombre"
                      :items="variablesForm.tipoViaAcceso"
                      return-object
                      chips
                      label="Tipo de vía de acceso"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="nuevaFinca.fuenteAgua.tipoFuentes"
                      item-text="nombre"
                      :items="variablesForm.tipoFuenteAguaFinca"
                      label="Fuentes de Agua"
                      outlined
                      return-object
                      chips
                      deletable-chips
                      multiple
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="nuevaFinca.fuenteAgua.almacenamiento"
                      item-text="nombre"
                      :items="variablesForm.tipoAlmacenamientoAgua"
                      label="Almacenamiento de Agua"
                      outlined
                      return-object
                      chips
                      deletable-chips
                      multiple
                    ></v-select>
                  </v-col>
                </v-row>

                <v-subheader style="padding:0;font-size:14pt;height: 30px;">Items</v-subheader>

                <p
                  class="grey--text text--lighten-1"
                >Cuentanos un poco más sobre la infraestructura de tu finca. Así podremos ayudarte a encontrar nuevas oportunidades.</p>

                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-autocomplete
                      v-model="items"
                      :items="variablesForm.itemsProductor"
                      outlined
                      chips
                      color="blue-grey lighten-2"
                      label="¿Qué items posees?"
                      item-text="nombre"
                      item-value="idItem"
                      multiple
                      :rules="[rules.requiredMultiple]"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="removeItem(data.item)"
                        >
                          <v-avatar left>
                            <v-img :src="data.item.data.imagen.secure_url"></v-img>
                          </v-avatar>
                          {{ data.item.nombre }}
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-avatar>
                            <img :src="data.item.data.imagen.secure_url" />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.nombre"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <div>
              <v-btn color="primary" @click="continuarUsuarioStepper">Continuar</v-btn>
              <v-btn text @click="stepperRegistro=1">Atrás</v-btn>
            </div>
          </div>
        </v-stepper-content>

        <v-stepper-step step="3">
          <span style="line-height: 30px;">Cuéntanos sobre ti</span>
          <small>Tu nombre e informacion de contacto</small>
        </v-stepper-step>

        <v-stepper-content step="3">
          <div>
            <div>
              <v-form ref="formUsuario">
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="usuario.nombres"
                      label="Nombres"
                      name="nombre"
                      outlined
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="usuario.apellidos"
                      label="Apellidos"
                      name="apellidos"
                      outlined
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                    <v-select
                      v-model="usuario.documento.tipo"
                      item-value="id"
                      item-text="nombre"
                      :items="variablesForm.tiposDocumento"
                      return-object
                      label="Tipo de Documento"
                      outlined
                    >
                      <template v-slot:selection="{item}">
                        <span>{{ item.abr }}</span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="5" lg="5" xl="5">
                    <v-text-field
                      v-model="usuario.documento.numero"
                      label="N° Documento"
                      prepend-icon="mdi-account-card-details-outline"
                      outlined
                      name="documento"
                      type="number"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                      v-model="usuario.telefonos[0].numero"
                      label="Celular"
                      prepend-icon="mdi-phone"
                      outlined
                      name="celular"
                      :rules="[rules.required]"
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-dialog
                      ref="dialog"
                      v-model="modalFechaNacimiento"
                      :return-value.sync="date"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateFormatted"
                          label="Fecha de Nacimiento"
                          prepend-icon="mdi-calendar-today"
                          readonly
                          outlined
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="pickerBirthday"
                        locale="es"
                        v-model="date"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1940-01-01"
                        scrollable
                      >
                        <div class="flex-grow-1"></div>
                        <v-btn text color="primary" @click="modalFechaNacimiento = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                      v-model="usuario.data.sexo"
                      item-text="sexo"
                      item-value="id"
                      :items="variablesForm.sexos"
                      return-object
                      label="Sexo"
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="usuario.correo"
                      label="Correo Electronico"
                      prepend-icon="mdi-email-outline"
                      outlined
                      type="email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="usuario.password"
                      :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                      label="Contraseña"
                      prepend-icon="mdi-lock"
                      outlined
                      :type="showPass ? 'text' : 'password'"
                      :rules="[rules.required,min]"
                      @click:append="showPass = !showPass"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Productor -->
                <v-row :dense="breakpoint=='xs'">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-select
                      v-model="nuevoProductor.data.necesidades"
                      item-text="nombre"
                      :items="variablesForm.necesidadesProductor "
                      label="¿Que necesidades tienes?"
                      outlined
                      return-object
                      chips
                      deletable-chips
                      multiple
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <v-select
                      v-model="nuevoProductor.data.origenRegistro"
                      item-text="nombre"
                      :items="origen"
                      return-object
                      label="Como llegaste a Cultivando Futuro"
                      outlined
                      chips
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
              <!-- Terminos y Condiciones -->
              <v-row class="px-2" align="center" justify="center">
                <v-checkbox class="mt-0" v-model="terminosCondiciones">
                  <template v-slot:label>
                    <div>
                      Acepto los
                      <a
                        target="_blank"
                        href="https://app.cultivandofuturo.com/documentos-legales/terminos-condiciones"
                        @click.stop
                      >Terminos y Condiciones de uso</a>
                    </div>
                  </template>
                </v-checkbox>
              </v-row>
            </div>
            <v-btn
              color="primary"
              large
              @click="finalizarRegistro()"
              :loading="loading"
            >Finalizar Registro</v-btn>
            <v-btn text large @click="stepperRegistro=2">Atrás</v-btn>
          </div>
        </v-stepper-content>
      </v-stepper>
      <v-row>
        <v-col>
          <p
            class="grey--text text--lighten-1 mb-0 mt-1"
          >Copyright © 2014-2020 Cultivando Futuro S.A.S - agro@cultivandofuturo.com</p>
        </v-col>
      </v-row>
    </div>
    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
    >{{ snackbar.text }}</v-snackbar>
    <v-dialog v-model="dialogCodigo" persistent max-width="500px">
      <v-card :color="$vuetify.theme.themes.dark.secondary">
        <v-card-title>
          <v-col class="pb-0">
            <span style="font-weight: 600;font-size: 20pt;">Registro Exitoso</span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-row style="font-size: 12pt;">
              <v-col>
                <p
                  class="mb-2 grey--text text--lighten-4"
                  style="font-size: 15pt;line-height: 28px;"
                >
                  ¡Ahora haces parte de la comunidad agro mas grande del país! Bienvenido a
                  <b>Cultivando Futuro</b>
                </p>
                <p
                  class="mb-2 grey--text text--lighten-4"
                >Para validar tu cuenta te enviamos un SMS a tu teléfono.</p>
                <p
                  class="mb-0 grey--text text--lighten-4"
                >Por favor digita el código a continuación:</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-form ref="codigoCognito">
                  <v-text-field
                    v-model="codigoCognito"
                    label="Codigo SMS"
                    outlined
                    :rules="[rules.required,rules.counter6]"
                    type="number"
                  ></v-text-field>
                </v-form>
              </v-col>
            </v-row>
            <div class="text-center">
              <v-btn
                :loading="loadingCodigo"
                @click="confirmAccount()"
                large
                color="primary"
              >Validar mi cuenta</v-btn>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCodigoConfirmacion" persistent max-width="500px">
      <v-card :color="$vuetify.theme.themes.dark.secondary">
        <v-card-title>
          <v-col class="pb-0">
            <span style="font-weight: 600;font-size: 20pt;">Registro Exitoso</span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-row style="font-size: 12pt;">
              <v-col>
                <p
                  class="mb-2 grey--text text--lighten-4"
                  style="font-size: 15pt;line-height: 28px;"
                >
                  ¡Ahora haces parte de la comunidad agro mas grande del país! Bienvenido a
                  <b>Cultivando Futuro</b>
                </p>
                <p
                  class="mb-2 grey--text text--lighten-4"
                >No olvides descargar nuestra aplicación para estar al tanto de servicios a tu medida:</p>

                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=cf.cultivandofuturo.app&hl=es_CO&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                >
                  <img
                    class="download-app-button"
                    alt="Disponible en Google Play"
                    src="https://play.google.com/intl/en_us/badges/images/generic/es_badge_web_generic.png"
                    style="width: 220px;"
                  />
                </a>
              </v-col>
            </v-row>
            <div class="text-center">
              <v-btn @click="volverInicio()" color="primary">Volver al Calendario</v-btn>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogErrorRegistro" persistent max-width="550px">
      <v-card dark color="error">
        <v-card-title style="font-weight: 600;font-size: 20pt;">
          <v-col class="pb-0">{{textError}}</v-col>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-row style="font-size: 12pt;">
              <v-col>
                <p
                  class="mb-2 grey--text text--lighten-4"
                  style="font-size: 15pt;line-height: 28px;"
                >
                  Hubo un error inesperado en tu registro, por favor notificanos de este error escribiendo a nuestro
                  <b>
                    <a
                      href="https://wa.me/573057381660?text=Tengo%20un%20problema%20en%20mi%20registro%20de%20Cultivando%20Futuro"
                      style="color:white"
                    >Whatsapp</a>
                  </b>
                  <br />
                  <br />O vuelve a la página de Inicio de
                  <a
                    href="https://cultivandofuturo.com"
                    style="color:white"
                  >Cultivando Futuro</a>.
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const { DateTime } = require("luxon");

import api from "@/api/api.js";

import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "RegistrarProductor",
  components: {
    HelloWorld
  },
  data: () => ({
    stepperRegistro: 1,
    productos: [],
    produccion: {
      producto: null,
      extension: {
        extensionText: null,
        extensionRaw: 0,
        extensionObj: {
          valor: null,
          unidad: null
        }
      },
      estado: {
        id: 2 //Produccion activa
      },
      rangoProduccion: {
        start: null,
        end: null,
        volumen: {
          unidad: null,
          valor: null,
          frecuencia: null
        }
      }
    },
    rangoProduccionStart: null,
    rangoProduccionEnd: null,
    variablesForm: {
      unidadesFrecuencia: [
        {
          id: 1,
          momentKey: "d",
          nombre: { plu: "Dias", sin: "Dia" },
          nombrePeriodicidad: "Diario",
          type: "simple"
        },
        {
          id: 2,
          momentKey: "w",
          nombre: { plu: "Semanas", sin: "Semana" },
          nombrePeriodicidad: "Semanal",
          type: "group",
          value: { idChild: 1, value: 7 }
        },
        {
          id: 3,
          nombre: { plu: "Quincenas", sin: "Quincena" },
          nombrePeriodicidad: "Quincenal",
          type: "group",
          value: { idChild: 1, value: 15 }
        },
        {
          id: 4,
          momentKey: "M",
          nombre: { plu: "Meses", sin: "Mes" },
          nombrePeriodicidad: "Mensual",
          type: "simple"
        },
        {
          id: 5,
          nombre: { plu: "Bimestres", sin: "Bimestre" },
          nombrePeriodicidad: "Bimestral",
          type: "group",
          value: { idChild: 4, value: 2 }
        },
        {
          id: 6,
          nombre: { plu: "Trimestres", sin: "Trimestre" },
          nombrePeriodicidad: "Trimestral",
          type: "group",
          value: { idChild: 4, value: 3 }
        },
        {
          id: 7,
          nombre: { plu: "Semestres", sin: "Semestre" },
          nombrePeriodicidad: "Semestral",
          type: "group",
          value: { idChild: 4, value: 6 }
        },
        {
          id: 8,
          momentKey: "y",
          nombre: { plu: "Años", sin: "Año" },
          nombrePeriodicidad: "Anual",
          type: "simple"
        },
        {
          id: 9,
          momentKey: null,
          nombre: { plu: "Cosecha", sin: "Cosecha" },
          nombrePeriodicidad: "Por Cosecha",
          type: "simple"
        }
      ],
      unidadesPeso: [
        {
          Id: "tn",
          Name: {
            Sin: {
              es: "Tonelada"
            },
            Plu: {
              es: "Toneladas"
            }
          },
          Value: 1000000,
          Unidad: {
            Name: {
              Sin: {
                es: "Gramo"
              },
              Plu: {
                es: "Gramos"
              }
            }
          }
        },
        {
          Id: "kg",
          Name: {
            Sin: {
              es: "kilogramo"
            },
            Plu: {
              es: "Kilogramos"
            }
          },
          Value: 1000,
          Unidad: {
            Name: {
              Sin: {
                es: "Gramo"
              },
              Plu: {
                es: "Gramos"
              }
            }
          }
        }
      ],
      unidadesExtension: [
        {
          abr: { plu: "m2", sin: "m2" },
          idTipoUnidad: 2,
          idUnidad: 6,
          nombre: { plu: "Metros Cuadrados", sin: "Metro Cuadrado" },
          unidad: 1
        },
        {
          abr: { plu: "fngs", sin: "fng" },
          idTipoUnidad: 2,
          idUnidad: 7,
          nombre: { plu: "Fanegadas", sin: "Fanegada" },
          unidad: 6400
        },
        {
          abr: { plu: "cds", sin: "cd" },
          idTipoUnidad: 2,
          idUnidad: 18,
          nombre: { plu: "Cuadras", sin: "Cuadra" },
          unidad: 6400
        },
        {
          abr: { plu: "ha", sin: "ha" },
          idTipoUnidad: 2,
          idUnidad: 8,
          nombre: { plu: "Hectáreas", sin: "Hectárea" },
          unidad: 10000
        }
      ],
      tipoViaAcceso: [
        { id: 1, nombre: "Ninguna", slug: "ninguna" },
        { id: 2, nombre: "Pavimentada", slug: "pavimentada" },
        { id: 3, nombre: "No pavimentada", slug: "no-pavimentada" },
        { id: 4, nombre: "Otra", slug: "otra" }
      ],
      estadoViaAcceso: [
        { id: 1, nombre: "Buena", slug: "buena" },
        { id: 2, nombre: "Regular", slug: "regular" },
        { id: 3, nombre: "Mala", slug: "mala" }
      ],
      tipoFuenteAguaFinca: [
        { id: 1, nombre: "Ninguna", slug: "ninguna" },
        { id: 2, nombre: "Pozo profundo ", slug: "pozo-profundo" },
        { id: 3, nombre: "Laguna o lago", slug: "laguna-o-lago" },
        { id: 4, nombre: "Rio o quebrada", slug: "rio-o-quebrada" },
        {
          id: 5,
          nombre: "Distrito de riego",
          slug: "distrito-de-riego"
        },
        { id: 6, nombre: "Otra", slug: "otra" },
        { id: 7, nombre: "Agua Potable", slug: "agua-potable" }
      ],
      tipoAlmacenamientoAgua: [
        { id: 1, nombre: "Ninguno", slug: "ninguno" },
        { id: 2, nombre: "Reservorio", slug: "reservorio" },
        { id: 3, nombre: "Tanques de agua", slug: "tanques-de-agua" }
      ],
      paises: [],
      departamentos: [],
      municipios: [],
      veredas: [],
      itemsProductor: [],
      tiposDocumento: [
        { abr: "NIT", id: 6, nombre: "NIT" },
        { abr: "RC", id: 5, nombre: "Registro Civil de Nacimiento" },
        { abr: "PP", id: 3, nombre: "Pasaporte" },
        { abr: "TI", id: 4, nombre: "Tarjeta de Identidad" },
        { abr: "CE", id: 2, nombre: "Cédula de Extranjería" },
        { abr: "CC", id: 1, nombre: "Cédula de Ciudadanía" }
      ],
      sexos: [
        {
          id: 1,
          abr: "M",
          sexo: "Masculino"
        },
        {
          id: 2,
          abr: "F",
          sexo: "Femenino"
        },
        {
          id: 3,
          abr: "O",
          sexo: "Otro"
        }
      ],
      necesidadesProductor: [
        {
          id: 1,
          nombre: "Asistencia Técnica",
          slug: "asistencia-tecnica"
        },
        { id: 2, nombre: "Prestamos", slug: "prestamos" },
        {
          id: 3,
          nombre: "Asesoría Financiera",
          slug: "asesoria-financiera"
        },
        { id: 4, nombre: "Certificaciones", slug: "certificaciones" },
        {
          id: 5,
          nombre: "Acceso a Mercados",
          slug: "acceso-a-mercados"
        },
        { id: 6, nombre: "Asesoría Legal", slug: "asesoria-legal" },
        {
          id: 7,
          nombre: "Logística para sus productos",
          slug: "logistica-para-sus-productos"
        },
        { id: 8, nombre: "Tecnificación", slug: "tecnificacion" }
      ]
    },
    rules: {
      required: value => !!value || "Campo Requerido",
      requiredMultiple: value => {
        if (value.length > 0) {
          return true;
        } else {
          return "Debes seleccionar al menos un item.";
        }
      },
      counter: value => value.length <= 20 || "Max 20 characters",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "No es un email válido";
      },
      counter6: value =>
        value.length == 6 || "El código debe contener 6 digitos"
    },
    modelRangoProduccionStart: false,
    modelRangoProduccionEnd: false,
    idPais: 42,
    departamento: null,
    municipio: null,
    tabmodel: null,
    nuevaFinca: {
      nombre: null,
      extension: {
        extensionText: null,
        extensionRaw: 0,
        extensionObj: {
          valor: null,
          unidad: null
        }
      },
      viaAcceso: {
        tipo: null,
        estado: null,
        distanciaCabecera: null
      },
      fuenteAgua: {
        tipoFuentes: [],
        almacenamiento: []
      },
      data: {
        puntoReferencia: null
      },
      idCiudad: null,
      idLocalidad: null,
      searchUbicacion: {
        service: "google",
        geo: {
          lat: null,
          lng: null
        },
        google: {
          hash: null
        },
        w3w: {
          hash: null
        }
      }
    },
    nombreDept: null,
    nombreMun: null,
    items: [],
    usuario: {
      nombres: null,
      apellidos: null,
      documento: {
        tipo: {
          abr: "CC",
          id: 1,
          nombre: "Cédula de Ciudadanía"
        },
        numero: null
      },
      correo: null,
      password: null,
      telefonos: [
        {
          numero: null,
          codigoPais: "+57"
        }
      ],
      urlImagen: null,
      data: {
        sexo: null,
        fechaNacimiento: null
      },
      password: null
    },
    date: "",
    modalFechaNacimiento: false,
    nombres: null,
    apellidos: null,
    showPass: false,
    nuevoProductor: {
      tipoPoblacion: [],
      escolaridad: {
        nivel: null,
        ultimoGradoAprobado: null
      },
      asistenciaTecnica: {
        asistencia: false,
        origen: null,
        programa: null
      },
      informacionFinanciera: {
        serviciosFinancieros: {
          usaServicios: false,
          servicios: []
        },
        creditos: [],
        ingresoFamiliarAgropecuario: {
          unidad: null,
          valor: null
        }
      },
      asociatividad: {
        asociado: false,
        nombreAsociacion: null,
        periodiciadReuniones: null,
        laborAsociacion: null,
        produccionEnSocia: {
          tiene: false,
          socios: []
        }
      },
      manejoResiduos: {
        manejo: false,
        tipo: null
      },
      transporteComercializacion: {
        poseeTransporte: false,
        tipoTransporte: []
      },
      data: {
        necesidades: [],
        profesion: null,
        numeroFamiliares: 0,
        capacitaciones: {
          recibidas: null,
          necesarias: null
        },
        sitioVenta: [],
        aQuienVende: [],
        formaPago: [],
        procesosInnovacion: {
          innovacion: false,
          descripcion: null
        }
      }
    },
    origen: [
      { id: 9, nombre: "Mercados Solidarios Minuto de Dios" },
      { id: 7, nombre: "Agroredes" },
      { id: 1, nombre: "Por redes sociales" },
      { id: 2, nombre: "Por referencia de un amigo" },
      { id: 3, nombre: "Directamente por nuestra pagina" },
      { id: 4, nombre: "Buscando en Google, Bing o Yahoo" },
      {
        id: 5,
        nombre: "Por medios digitales: articulos, noticias, videos"
      },
      { id: 8, nombre: "Otro" },
      { id: 'whatsapp', nombre: "Whatsapp" },
      { id: 'el-campo-a-un-clic', nombre: "El Campo a un Clic" }
    ],
    loading: false,
    loadingCodigo: false,
    terminosCondiciones: false,
    dialogCodigo: false,
    dialogCodigoConfirmacion: false,
    codigoCognito: null,
    dialogErrorRegistro: false,
    snackbar: {
      show: false,
      text: null,
      color: null
    },
    textError: "¡Hubo un error inesperado!"
  }),
  async mounted() {
    this.getProductos();
    this.variablesForm.paises = await api.getPaises();
    this.variablesForm.departamentos = await api.getDepartamentos(42);
    this.variablesForm.itemsProductor = await api.getItems();
  },
  methods: {
    async getProductos() {
      let productos = await api.getProductos();

      let productosFilt = productos.filter(prod => {
        if (prod.tipoProducto == "agricola") {
          return true;
        }
      });

      productosFilt.sort((a, b) => {
        let comparison = 0;
        if (a.nombre > b.nombre) {
          comparison = 1;
        } else if (a.nombre < b.nombre) {
          comparison = -1;
        }
        return comparison;
      });

      this.productos = productosFilt;
    },
    formatDateStart(val) {
      this.produccion.rangoProduccion.start = DateTime.fromISO(val).toString();
    },
    formatDateEnd(val) {
      this.produccion.rangoProduccion.end = DateTime.fromISO(val).toString();
    },
    continuarFincaStepper() {
      if (this.$refs.formProducto.validate()) {
        if (
          this.produccion.rangoProduccion.start &&
          this.produccion.rangoProduccion.end
        ) {
          this.stepperRegistro = 2;
        } else {
          this.showSnackbar(
            "¡Por favor completa tu próximo rango de cosecha!",
            "error"
          );
        }
      } else {
        this.showSnackbar(
          "¡Por favor completa los campos para continuar!",
          "error"
        );
      }
    },
    //Finca
    async getCiudades(data) {
      this.nombreDept = data.nombre;
      this.variablesForm.municipios = await api.getMunicipios(
        data.id_departamento
      );
    },
    setMunicipio(data) {
      this.nombreMun = data.nombre_ciudad;
      this.nuevaFinca.idCiudad = data.id_ciudad;
    },
    removeItem(itemEval) {
      const index = this.items.findIndex(
        item => item.idItem == itemEval.idItem
      );
      if (index >= 0) this.items.splice(index, 1);
    },
    continuarUsuarioStepper() {
      if (this.$refs.formFinca.validate()) {
        let hash = this.nombreMun + " " + this.nombreDept + " Colombia";
        this.nuevaFinca.searchUbicacion.google.hash = hash.toLowerCase();
        this.stepperRegistro = 3;
      } else {
        this.showSnackbar(
          "¡Por favor completa los campos para continuar!",
          "error"
        );
      }
    },
    //Usuario
    formatDate(val) {
      this.usuario.data.fechaNacimiento = DateTime.fromISO(val).toString();
    },
    min(value) {
      if (value) {
        return value.length >= 6 || "La contraseña minimo debe tener 6 digitos";
      } else {
        return false;
      }
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    finalizarRegistro() {
      if (this.$refs.formUsuario.validate()) {
        if (this.terminosCondiciones) {
          let nuevoProductor = {
            usuario: this.usuario,
            productor: this.nuevoProductor,
            finca: this.nuevaFinca,
            produccion: this.produccion,
            items: this.items
          };

          this.loading = true;

          api.registrarProductor(nuevoProductor).then(data => {
            this.loading = false;
            if (data.status) {
              this.dialogCodigo = true;
            } else {
              this.textError = data.err.msg;
              this.dialogErrorRegistro = true;
            }
          });
        } else {
          this.loading = false;
          this.showSnackbar(
            "¡Acepta los términos y condiciones para continuar!",
            "error"
          );
        }
      } else {
        this.showSnackbar(
          "¡Por favor completa los campos para continuar!",
          "error"
        );
      }
    },
    confirmAccount() {
      this.loadingCodigo = true;
      if (this.$refs.codigoCognito.validate()) {
        let username = this.usuario.documento.numero.toString();
        let codigo = this.codigoCognito.toString();

        api.confirmAccount(username, codigo).then(data => {
          this.loadingCodigo = false;
          if (data.status) {
            this.loadingCodigo = false;
            this.dialogCodigo = false;
            this.dialogCodigoConfirmacion = true;
          } else {
            this.dialogErrorRegistro = true;
            console.error(data);
          }
        });
      } else {
        this.loadingCodigo = false;
      }
    },
    volverInicio() {
      this.dialogCodigoConfirmacion = false;
      this.$router.replace({ path: "/" });
    },
    volver() {
      this.$router.push({ path: "/" });
    }
  },
  computed: {
    dateFormatted() {
      return this.date
        ? DateTime.fromISO(this.date)
            .setLocale("es")
            .toFormat("dd MMMM y")
        : "";
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    }
  },
  watch: {
    modalFechaNacimiento(val) {
      val &&
        setTimeout(() => (this.$refs.pickerBirthday.activePicker = "YEAR"));
    },
    rangoProduccionStart: "formatDateStart",
    rangoProduccionEnd: "formatDateEnd",
    date: "formatDate"
  }
};
</script>